import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import Home from '../components/Home';



class Routes extends Component {

  render () {
    return (
      <BrowserRouter>
        <div>
          <Switch>
            <Route path='/' exact>
              { ({ match }) => <Home show={ match !== null } /> }
            </Route>
          </Switch>
        </div>
      </BrowserRouter>
    )
  }

}




export default Routes;
